import Model, { attr } from "@ember-data/model";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";

export default class InviteModel extends Model {
  @service ajax;
  @service session;

  @attr sender;
  @attr status;
  @attr recipient;
  @attr created;
  @attr invitecode;
  @attr permissions;

  get organizationId() {
    return this.permissions?.[0]?.customernumber;
  }

  get organizationName() {
    return this.permissions?.[0]?.organizationname;
  }

  async accept() {
    await this.ajax.post(`${ENV.apiBaseUri}/invite/accept`, {
      data: { invitecode: this.id },
    });

    let user = this.session.currentUser;
    await Promise.all([user.get("invites").reload(), user.get("organizations").reload()]);
  }
}
